import React from 'react'
import {
  GridRowsProp,
  GridRowModesModel,
  GridRowModes,
  GridToolbarContainer,
  GridToolbarExport,
} from '@mui/x-data-grid-pro'
import { Button, IconButton, useTheme } from '@mui/material'
import { AddCircle, Upload } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import DataGridDefaultBulkActions from './DataGridDefaultBulkActions'

interface EditToolbarProps {
  setItems: (newRows: (oldRows: GridRowsProp) => GridRowsProp) => void;
  setRowModesModel: (
    newModel: (oldModel: GridRowModesModel) => GridRowModesModel,
  ) => void;
  toolBarConfig: {
    add?: boolean,
    export?: boolean,
    upload?: boolean,
  };
  selectionModel: any,
  enableBulkActions: boolean,
  bulkActionsMenu?: any,
  addAction?: Function,
  queryKey: string[],
  setGridFilters: Function,
  setSelectionModel: Function,
  snackbarItems: any,
  csvExportFields: string[],
  uploadPath?: string,
}

//const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
  //gridVisibleSortedRowIdsSelector(apiRef);

const DataGridEditToolbar = (props: EditToolbarProps) => {
  const {
    setItems,
    setRowModesModel,
    toolBarConfig,
    selectionModel,
    enableBulkActions,
    bulkActionsMenu,
    addAction,
    queryKey,
    setGridFilters,
    setSelectionModel,
    csvExportFields,
    uploadPath,
  } = props;
  const navigate = useNavigate()
  const theme = useTheme()
  const BulkActionsMenuComponent = (bulkActionsMenu) ? bulkActionsMenu : DataGridDefaultBulkActions
  const printOptions = {
    disableToolbarButton: true,
  }
  const csvOptions = {
    fields: csvExportFields
  }

  const handleClick = () => {
    if (addAction) {
      addAction()
      return
    }
    const id = crypto.randomUUID();
    setItems((oldRows) => [...oldRows, { id, label: '', value: '', isNew: true }]);
    setRowModesModel((oldModel) => ({
      ...oldModel,
      [id]: { mode: GridRowModes.Edit, fieldToFocus: 'label' },
    }));
  }
  // const apiRef = useGridApiContext();
  // const buttonBaseProps: ButtonProps = {
  //   color: 'primary',
  //   size: 'small',
  //   startIcon: <FileDownloadIcon />,
  // }

  // const handleExport = (options: GridCsvExportOptions) =>
  //   apiRef.current.exportDataAsCsv(options);

  return (
    <GridToolbarContainer sx={{ flexDirection: 'row-reverse', borderBlockEnd: `1px solid ${theme.palette.secondary.light}`, height: 60 }}>
      {(toolBarConfig.add)
        ?
        <IconButton
          sx={{ marginLeft: 1 }}
          color="secondary"
          size='large'
          onClick={handleClick}>
          <AddCircle fontSize='inherit' />
        </IconButton>
        : null
      }
      {(toolBarConfig.export)
        ? <GridToolbarExport printOptions={printOptions} csvOptions={csvOptions} />
        : null
      }
      {(toolBarConfig.upload)
        ? <Button
          sx={{ marginRight: 1 }}
          variant='text'
          color="primary"
          startIcon={<Upload />}
          onClick={() => navigate(`${uploadPath}`)}>
          Upload
        </Button>
        : null
      }
      {
        (enableBulkActions && selectionModel.length)
          ? <BulkActionsMenuComponent
            selectionModel={selectionModel}
            queryKey={queryKey}
            setGridFilters={setGridFilters}
            setSelectionModel={setSelectionModel}
          />
          : null
      }
    </GridToolbarContainer>
  )
}

export default DataGridEditToolbar